import { ANYTHING, CacheScenario, CacheTime, MethodType } from 'app/models/api/cache';
import { CustomFieldCategory } from 'app/models/api/custom-fields';
import { API_ENDPOINT } from './utils.service';

export const userFieldsServiceCache: () => CacheScenario[] = (): CacheScenario[] => [
  {
    description: 'method getCustomFields, caching user defined fields, for machines',
    cacheTime: CacheTime.DEFAULT,
    endpoint: {
      url: `${API_ENDPOINT}/customfields/${CustomFieldCategory.machines}`,
      method: MethodType.GET,
    },
    cleaningEndpoints: [
      {
        url: `${API_ENDPOINT}/customfields/${CustomFieldCategory.machines}`,
        method: MethodType.POST,
      },
      {
        url: `${API_ENDPOINT}/customfields/${CustomFieldCategory.machines}/${ANYTHING}`,
        method: MethodType.POST,
      },
      {
        url: `${API_ENDPOINT}/customfields/${CustomFieldCategory.machines}/${ANYTHING}`,
        method: MethodType.DELETE,
      },
    ],
  },
  {
    description: 'method getCustomFields, caching user defined fields, for incidents',
    cacheTime: CacheTime.DEFAULT,
    endpoint: {
      url: `${API_ENDPOINT}/customfields/${CustomFieldCategory.incidents}`,
      method: MethodType.GET,
    },
    cleaningEndpoints: [
      {
        url: `${API_ENDPOINT}/customfields/${CustomFieldCategory.incidents}`,
        method: MethodType.POST,
      },
      {
        url: `${API_ENDPOINT}/customfields/${CustomFieldCategory.incidents}/${ANYTHING}`,
        method: MethodType.POST,
      },
      {
        url: `${API_ENDPOINT}/customfields/${CustomFieldCategory.incidents}/${ANYTHING}`,
        method: MethodType.DELETE,
      },
    ],
  },
  {
    description: 'method getCustomFields, caching user defined fields, for events',
    cacheTime: CacheTime.DEFAULT,
    endpoint: {
      url: `${API_ENDPOINT}/customfields/${CustomFieldCategory.events}`,
      method: MethodType.GET,
    },
    cleaningEndpoints: [
      {
        url: `${API_ENDPOINT}/customfields/${CustomFieldCategory.events}`,
        method: MethodType.POST,
      },
      {
        url: `${API_ENDPOINT}/customfields/${CustomFieldCategory.events}/${ANYTHING}`,
        method: MethodType.POST,
      },
      {
        url: `${API_ENDPOINT}/customfields/${CustomFieldCategory.events}/${ANYTHING}`,
        method: MethodType.DELETE,
      },
    ],
  },
  {
    description: 'method getCustomFields, caching user defined fields, for tasks',
    cacheTime: CacheTime.DEFAULT,
    endpoint: {
      url: `${API_ENDPOINT}/customfields/${CustomFieldCategory.tasks}`,
      method: MethodType.GET,
    },
    cleaningEndpoints: [
      {
        url: `${API_ENDPOINT}/customfields/${CustomFieldCategory.tasks}`,
        method: MethodType.POST,
      },
      {
        url: `${API_ENDPOINT}/customfields/${CustomFieldCategory.tasks}/${ANYTHING}`,
        method: MethodType.POST,
      },
      {
        url: `${API_ENDPOINT}/customfields/${CustomFieldCategory.tasks}/${ANYTHING}`,
        method: MethodType.DELETE,
      },
    ],
  },
  {
    description: 'method getCustomFields, caching user defined fields, for repair tasks',
    cacheTime: CacheTime.DEFAULT,
    endpoint: {
      url: `${API_ENDPOINT}/customfields/${CustomFieldCategory.repairTasks}`,
      method: MethodType.GET,
    },
    cleaningEndpoints: [
      {
        url: `${API_ENDPOINT}/customfields/${CustomFieldCategory.repairTasks}`,
        method: MethodType.POST,
      },
      {
        url: `${API_ENDPOINT}/customfields/${CustomFieldCategory.repairTasks}/${ANYTHING}`,
        method: MethodType.POST,
      },
      {
        url: `${API_ENDPOINT}/customfields/${CustomFieldCategory.repairTasks}/${ANYTHING}`,
        method: MethodType.DELETE,
      },
    ],
  },
];
